import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { useLocation } from 'react-router'

import { useCurrentSurvey } from '~/hooks/useCurrentSurvey'
import { exists } from '~/utils'

const measurementId: string | undefined = process.env.GA_MEASUREMENT_ID

const script = document.createElement('script')
script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${measurementId}');`

const noscript = document.createElement('noscript')
noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${measurementId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`

export const useGTag = () => {
  const { isLoading, user } = useAuth0()
  const { pathname } = useLocation()
  const currentSurvey = useCurrentSurvey()

  React.useEffect(() => {
    if (exists(measurementId)) {
      document.head.prepend(script)
      document.body.prepend(noscript)
    }
  }, [])

  React.useEffect(() => {
    if (isLoading || !exists(window.dataLayer) || !exists(measurementId)) {
      return
    }

    const surveyId = currentSurvey.success ? currentSurvey.value.id : undefined
    window.dataLayer.push({
      pathname,
      survey_id: surveyId,
      user_id: user?.sub,
    })
  }, [currentSurvey, isLoading, pathname, user?.sub])
}
